import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus, HelpCircle } from 'lucide-react';
const faqs = [{
  question: '¿Para quién es exactamente este sistema?',
  answer: "Este sistema está diseñado para terapeutas holísticos que ya practican Reiki y sienten que han llegado a un 'techo' técnico, así como para personas que desean iniciar su camino con una estructura profesional desde el día uno. Si buscas dejar de improvisar y quieres protocolos claros que den seguridad a tu práctica, esto es para ti."
}, {
  question: '¿Necesito tener conocimientos previos o ser Maestro Reiki?',
  answer: 'No es requisito ser Maestro. El Sistema Maestro de Reiki Terapéutico está estructurado para elevar el nivel de cualquier practicante (Nivel 1 en adelante). Te brindamos la infraestructura operativa que normalmente no se enseña en las sintonizaciones tradicionales: diagnóstico, seguimiento y protección profesional.'
}, {
  question: '¿Cómo recibo el material y por cuánto tiempo tengo acceso?',
  answer: 'El acceso es inmediato. Una vez realizado el pago, recibirás un correo electrónico con tus credenciales de acceso a la plataforma. El acceso es vitalicio, incluyendo todas las actualizaciones futuras del kit. Puedes descargar los materiales y consultarlos en cualquier dispositivo, a tu ritmo.'
}, {
  question: '¿El material es editable para mis propias sesiones?',
  answer: '¡Exactamente! Las fichas de anamnesis, los protocolos de seguimiento y los diarios están diseñados en formatos prácticos (como Canva) para que puedas personalizarlos con tu propio logo y marca. Queremos que el sistema trabaje para tu autoridad profesional.'
}, {
  question: '¿Qué diferencia este kit de otros cursos de Reiki?',
  answer: "La mayoría de los cursos se enfocan solo en la técnica energética. Nosotros nos enfocamos en la metodología terapéutica. No solo 'pones las manos'; aprendes a realizar un diagnóstico preciso, a proteger tu propia energía para no terminar agotada y a entregar resultados tangibles que tus clientes puedan percibir."
}, {
  question: '¿Es seguro el pago y qué pasa si no es lo que esperaba?',
  answer: 'Tu pago está protegido por tecnología de encriptación de grado bancario. Además, confiamos tanto en la calidad de este arsenal operativo que cuentas con nuestra garantía de satisfacción. Si sientes que el material no eleva tu práctica profesional, estamos aquí para respaldarte.'
}, {
  question: '¿Puedo aplicarlo si atiendo de forma online?',
  answer: 'Totalmente. El sistema incluye protocolos adaptados tanto para la presencialidad como para sesiones a distancia. Las guías de protección y los mapas de diagnóstico emocional son herramientas universales que funcionan independientemente de la modalidad de tu consulta.'
}];
export function FAQ() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  return <section className="py-24 bg-white pt-[30px] pb-[30px]" data-id="element-205">
      <div className="max-w-3xl mx-auto px-4" data-id="element-206">
        <div className="text-center mb-16" data-id="element-207">
          <h2 className="text-violet-600 font-black uppercase tracking-[0.3em] mb-4 text-xs" data-id="element-208">
            DESPEJA TUS DUDAS
          </h2>
          <h3 className="text-4xl md:text-6xl text-violet-950 font-medium font-['Playfair_Display']" data-id="element-209">
            Preguntas Frecuentes
          </h3>
        </div>

        <div className="space-y-4" data-id="element-210">
          {faqs.map((faq, index) => <div key={index} className="border border-violet-100 rounded-2xl overflow-hidden transition-all duration-300 hover:border-violet-200" data-id="element-211">
              <button onClick={() => setActiveIndex(activeIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left bg-violet-50/30 hover:bg-violet-50 transition-colors" data-id="element-212">
                <span className="font-bold text-violet-950 pr-8 leading-tight" data-id="element-213">
                  {faq.question}
                </span>
                <div className="shrink-0 text-violet-600" data-id="element-214">
                  {activeIndex === index ? <Minus size={20} data-id="element-215" /> : <Plus size={20} data-id="element-216" />}
                </div>
              </button>

              <AnimatePresence data-id="element-217">
                {activeIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-218">
                    <div className="p-6 pt-0 text-violet-800/80 leading-relaxed bg-violet-50/30" data-id="element-219">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        <div className="mt-20 text-center border-t border-violet-100 pt-12" data-id="element-220">
          <div className="inline-flex items-center gap-2 text-violet-400 mb-6" data-id="element-221">
            <HelpCircle size={20} data-id="element-222" />
            <span className="text-sm font-medium uppercase tracking-widest" data-id="element-223">
              Maestría con Alma
            </span>
          </div>
          <p className="text-violet-900 font-serif italic text-xl max-w-lg mx-auto" data-id="element-224">
            "Tu don merece una estructura que lo sostenga. No solo sanas
            cuerpos, construyes un legado de luz profesional."
          </p>
        </div>
      </div>
    </section>;
}